import { render, staticRenderFns } from "./AddEditSubjectPool.vue?vue&type=template&id=20810d97"
import script from "./AddEditSubjectPool.vue?vue&type=script&lang=js"
export * from "./AddEditSubjectPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports